<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="124"
    height="124"
    viewBox="0 0 124 124"
    fill="none"
  >
    <g clip-path="url(#clip0_21917_45694)">
      <mask
        id="mask0_21917_45694"
        style="mask-type:luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="124"
        height="124"
      >
        <path d="M124 0H0V124H124V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_21917_45694)">
        <path
          d="M61.7927 22.0273C83.8869 22.0273 101.826 39.9661 101.826 62.0603C101.826 84.1545 83.8869 102.093 61.7927 102.093C39.6985 102.093 21.7598 84.1545 21.7598 62.0603C21.7598 39.9661 39.6985 22.0273 61.7927 22.0273Z"
          stroke="#FABC2D"
          stroke-width="6.2298"
        />
        <g opacity="0.619174">
          <path
            d="M61.7743 18.3047C85.9268 18.3047 105.537 37.9147 105.537 62.0673C105.537 86.2198 85.9268 105.83 61.7743 105.83C37.6217 105.83 18.0117 86.2198 18.0117 62.0673C18.0117 37.9147 37.6217 18.3047 61.7743 18.3047Z"
            stroke="#FABC2D"
            stroke-width="6.81019"
          />
        </g>
        <path
          d="M61.9992 20.4609C84.9412 20.4609 103.539 39.0591 103.539 62.0011C103.539 84.9432 84.9412 103.541 61.9992 103.541C39.0571 103.541 20.459 84.9432 20.459 62.0011C20.459 39.0591 39.0571 20.4609 61.9992 20.4609Z"
          fill="#FABC2D"
        />
        <path
          d="M62.2261 73.6028C65.0141 73.6028 66.9592 76.115 66.9592 78.3696C66.9592 81.0107 65.0141 83.5229 62.2261 83.5229C58.9841 83.5229 57.0391 81.0107 57.0391 78.3696C57.0391 76.115 58.9841 73.6028 62.2261 73.6028ZM63.5398 38.6211C64.787 38.6211 65.8525 39.6269 65.9123 40.8339L65.915 40.941V65.0175C65.915 66.2357 64.8851 67.2763 63.6494 67.3348L63.5398 67.3374H60.4585C59.2113 67.3374 58.1458 66.3315 58.0859 65.1245L58.0833 65.0175V40.941C58.0833 39.7228 59.1131 38.6822 60.3489 38.6237L60.4585 38.6211H63.5398Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_21917_45694">
        <rect width="124" height="124" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "IconWarningYellow",
};
</script>

<style></style>
